import { IFetchListRequestProps } from '@interfaces/common';

export const buildAdminSearchSupplementsPayload = ({
  page,
  sort,
  search,
  pageSize,
}: IFetchListRequestProps) => ({
  search: search || '',
  pagination: {
    page: page || 1,
    pageSize: pageSize || Number(process.env.REACT_APP_PAGE_SIZE_FOR_ADMIN_INQUIRIES_TABLE) || 5,
  },
  sort: sort || {
    active: '',
    direction: '',
  },
});
